import { atom } from '@reatom/framework'

import { AsyncStateN, pipe, Set } from '@blade/std-lib'

import { trackingWalletAlertsTableModel } from './reatom-tracking-wallets-alerts-table'

export type AlertTypeFilter = 'buy' | 'sell'
export const typeFilterAtom = atom(
  Set.create<AlertTypeFilter>(['buy', 'sell']),
  'typeFilterAtom',
)

export const walletAlertsListStateAtom = atom((ctx) => {
  const tableState = ctx.spy(trackingWalletAlertsTableModel)
  const typeFilter = ctx.spy(typeFilterAtom)

  return pipe(
    tableState,
    AsyncStateN.map((it) => {
      return it.data.filter((it) => typeFilter.has(it.type))
    }),
  )
}, 'walletAlertsListStateAtom')
